import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Customer, CustomerNarrative } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerNarrativeService extends TmsWebBaseEditService<Customer, CustomerNarrative> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CustomerNarrative', $localize`Customer Narrative`);
  }
}
